/* Tuokus live rebuild marker 2026-06-21 01:18 HKT */
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  var SWATCH_TRACK_SELECTOR = '.color-swatch-list--large, .block-swatch-list, .variant-swatch-list';
  var optionRootFrames = new WeakMap();
  var optionRealignFrames = Object.create(null);
  var optionRealignTimers = Object.create(null);
  var pickerRealignFrames = Object.create(null);
  var optionScrollMemory = Object.create(null);
  var lastOptionByForm = Object.create(null);
  var forcedVariantSyncTimers = Object.create(null);
  var dragState = null;

  function formUsesProductRerender(formId) {
    if (!formId) {
      return false;
    }

    return Boolean(document.querySelector('product-rerender[observe-form="' + formId + '"]'));
  }

  function getOptionKey(formId, optionPosition) {
    if (!formId || !optionPosition) {
      return null;
    }

    return formId + '::' + optionPosition;
  }

  function getOptionTrack(optionRoot) {
    if (!optionRoot || !optionRoot.querySelector) {
      return null;
    }

    return optionRoot.querySelector(SWATCH_TRACK_SELECTOR);
  }

  function getControlForm(control) {
    if (!control) {
      return null;
    }

    return control.form || document.forms[control.getAttribute('form')];
  }

  function getPickerForFormId(formId) {
    if (!formId) {
      return null;
    }

    return document.querySelector('variant-picker[form-id="' + formId + '"]');
  }

  function getOptionValuesForForm(form) {
    if (!form) {
      return [];
    }

    return Array.from(form.elements)
      .filter(function(item) {
        return item.matches(
          'input[data-option-position]:checked, ' +
          'input[data-option-position][type="hidden"], ' +
          'select[data-option-position]'
        );
      })
      .sort(function(a, b) {
        return parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10);
      })
      .map(function(input) {
        return input.value;
      });
  }

  function scheduleForcedVariantSync(control) {
    if (!control || !control.matches || !control.matches('.product-form__single-selector[data-option-position]')) {
      return;
    }

    var form = getControlForm(control);

    if (!form || !form.id) {
      return;
    }

    var formId = form.id;
    var picker = getPickerForFormId(formId);
    var variantIdInput = form.querySelector('[name="id"]');

    if (!picker || !variantIdInput || typeof picker.selectCombination !== 'function') {
      return;
    }

    window.clearTimeout(forcedVariantSyncTimers[formId]);

    var beforeVariantId = variantIdInput.value;
    var optionValues = getOptionValuesForForm(form);

    forcedVariantSyncTimers[formId] = window.setTimeout(function() {
      var afterVariantId = variantIdInput.value;

      if (!control.checked || beforeVariantId !== afterVariantId) {
        return;
      }

      picker.selectCombination({
        optionValues: optionValues,
        productChange: control.hasAttribute('data-product-url')
      });
    }, 160);
  }

  function rememberOptionScroll(formId, optionPosition, optionRoot) {
    var key = getOptionKey(formId, optionPosition);
    var track = getOptionTrack(optionRoot);

    if (!key || !track) {
      return;
    }

    optionScrollMemory[key] = track.scrollLeft;
    lastOptionByForm[formId] = optionPosition;
  }

  function restoreOptionScroll(formId, optionPosition, optionRoot) {
    var key = getOptionKey(formId, optionPosition);
    var track = getOptionTrack(optionRoot);
    var rememberedScrollLeft = key ? optionScrollMemory[key] : null;

    if (!track || typeof rememberedScrollLeft !== 'number') {
      return;
    }

    track.scrollLeft = rememberedScrollLeft;
  }

  function clearFrameBucket(frameBucket, key) {
    var frameIds = frameBucket[key];

    if (!frameIds) {
      return;
    }

    frameIds.forEach(window.cancelAnimationFrame);
    delete frameBucket[key];
  }

  function clearTimerBucket(timerBucket, key) {
    var timerIds = timerBucket[key];

    if (!timerIds) {
      return;
    }

    timerIds.forEach(window.clearTimeout);
    delete timerBucket[key];
  }

  function setTrackScroll(track, nextScrollLeft, behavior) {
    if (!track) {
      return;
    }

    var maxScrollLeft = Math.max(track.scrollWidth - track.clientWidth, 0);
    var clampedScrollLeft = Math.max(0, Math.min(nextScrollLeft, maxScrollLeft));

    if (Math.abs(clampedScrollLeft - track.scrollLeft) < 1) {
      return;
    }

    if (behavior === 'smooth' && typeof track.scrollTo === 'function') {
      track.scrollTo({
        left: clampedScrollLeft,
        behavior: 'smooth'
      });
    } else {
      track.scrollLeft = clampedScrollLeft;
    }
  }

  function persistTrackScroll(track) {
    if (!track || !track.closest) {
      return;
    }

    var optionRoot = track.closest('.product-form__option');
    var optionInput = optionRoot ? optionRoot.querySelector('[data-option-position]') : null;
    var formId = optionInput ? optionInput.getAttribute('form') || (optionInput.form ? optionInput.form.id : null) : null;
    var optionPosition = optionInput ? optionInput.getAttribute('data-option-position') : null;
    var key = getOptionKey(formId, optionPosition);

    if (!key) {
      return;
    }

    optionScrollMemory[key] = track.scrollLeft;
  }

  function scheduleOptionRootScroll(optionRoot, behavior) {
    if (!optionRoot) {
      return;
    }

    var existingFrames = optionRootFrames.get(optionRoot) || [];

    existingFrames.forEach(window.cancelAnimationFrame);

    var nextFrames = [];
    var frameId = window.requestAnimationFrame(function() {
      var settleFrameId = window.requestAnimationFrame(function() {
        scrollActiveSwatchIntoView(optionRoot, behavior);
      });

      optionRootFrames.set(optionRoot, [settleFrameId]);
    });

    nextFrames.push(frameId);
    optionRootFrames.set(optionRoot, nextFrames);
  }

  function bindProductRerenderListener(form) {
    if (!form || form.dataset.tuokusRerenderBound === 'true') {
      return;
    }

    form.dataset.tuokusRerenderBound = 'true';
    form.addEventListener('product:rerender', function() {
      var formId = form.id || null;
      var optionPosition = formId ? lastOptionByForm[formId] : null;
      var key = getOptionKey(formId, optionPosition);

      if (formId && optionPosition) {
        clearFrameBucket(optionRealignFrames, key);
        optionRealignFrames[key] = [];

        realignOption(formId, optionPosition, 'auto');

        optionRealignFrames[key].push(window.requestAnimationFrame(function() {
          realignOption(formId, optionPosition, 'auto');
        }));

        queueOptionRealignSettles(formId, optionPosition, 'auto');

        return;
      }

      queuePickerRealign(formId, 'auto');
    });
  }

  function initProductRerenderBindings() {
    document.querySelectorAll('variant-picker[form-id]').forEach(function(picker) {
      var formId = picker.getAttribute('form-id');

      if (!formId) {
        return;
      }

      bindProductRerenderListener(document.forms[formId]);
    });
  }

  function getActiveSwatch(optionRoot) {
    if (!optionRoot) return null;

    return optionRoot.querySelector(
      '.color-swatch__radio:checked + .color-swatch__item,' +
      '.block-swatch__radio:checked + .block-swatch__item,' +
      '.variant-swatch__radio:checked + .variant-swatch__item,' +
      '.color-swatch__item.is-selected,' +
      '.block-swatch__item.is-selected,' +
      '.variant-swatch__item.is-selected'
    );
  }

  function scrollActiveSwatchIntoView(optionRoot, behavior) {
    var activeSwatch = getActiveSwatch(optionRoot);

    if (!activeSwatch || !activeSwatch.closest) {
      return;
    }

    var track = activeSwatch.closest(SWATCH_TRACK_SELECTOR);

    if (!track) {
      return;
    }

    window.requestAnimationFrame(function() {
      var trackWidth = track.clientWidth;
      var maxScrollLeft = Math.max(track.scrollWidth - trackWidth, 0);

      if (!trackWidth || maxScrollLeft <= 0) {
        return;
      }

      var activeStyle = window.getComputedStyle(activeSwatch);
      var swatchStart = activeSwatch.offsetLeft - (parseFloat(activeStyle.marginLeft) || 0);
      var swatchEnd = activeSwatch.offsetLeft + activeSwatch.offsetWidth + (parseFloat(activeStyle.marginRight) || 0);
      var visiblePadding = Math.min(18, Math.max(10, trackWidth * 0.07));
      var viewportStart = track.scrollLeft;
      var viewportEnd = viewportStart + trackWidth;
      var nextScrollLeft = viewportStart;

      if (swatchStart < viewportStart + visiblePadding) {
        nextScrollLeft = swatchStart - visiblePadding;
      } else if (swatchEnd > viewportEnd - visiblePadding) {
        nextScrollLeft = swatchEnd - trackWidth + visiblePadding;
      }

      if (Math.abs(nextScrollLeft - viewportStart) < 1) {
        persistTrackScroll(track);
        return;
      }

      setTrackScroll(track, nextScrollLeft, behavior);
      persistTrackScroll(track);
    });
  }

  function queueSwatchScroll(optionRoot, behavior) {
    scheduleOptionRootScroll(optionRoot, behavior);
  }

  function findOptionRoot(formId, optionPosition) {
    if (!formId || !optionPosition) {
      return null;
    }

    var picker = document.querySelector('variant-picker[form-id="' + formId + '"]');

    if (!picker) {
      return null;
    }

    var optionInput = picker.querySelector('[data-option-position="' + optionPosition + '"]');

    return optionInput && optionInput.closest ? optionInput.closest('.product-form__option') : null;
  }

  function realignOption(formId, optionPosition, behavior) {
    var optionRoot = findOptionRoot(formId, optionPosition);

    if (!optionRoot) {
      realignPicker(formId, behavior);
      return;
    }

    if (!getActiveSwatch(optionRoot)) {
      restoreOptionScroll(formId, optionPosition, optionRoot);
    }

    scrollActiveSwatchIntoView(optionRoot, behavior);
  }

  function queueOptionRealignSettles(formId, optionPosition, behavior) {
    var key = getOptionKey(formId, optionPosition);

    if (!key) {
      return;
    }

    clearTimerBucket(optionRealignTimers, key);

    optionRealignTimers[key] = [24, 90, 180, 320].map(function(delay) {
      return window.setTimeout(function() {
        realignOption(formId, optionPosition, behavior);
      }, delay);
    });
  }

  function queueOptionRealign(formId, optionPosition, behavior) {
    var key = getOptionKey(formId, optionPosition);

    if (!key) {
      realignPicker(formId, behavior);
      return;
    }

    clearFrameBucket(optionRealignFrames, key);

    optionRealignFrames[key] = [];

    var frameId = window.requestAnimationFrame(function() {
      realignOption(formId, optionPosition, behavior);

      var settleFrameId = window.requestAnimationFrame(function() {
        realignOption(formId, optionPosition, behavior);
      });

      optionRealignFrames[key] = [settleFrameId];
    });

    optionRealignFrames[key].push(frameId);
    queueOptionRealignSettles(formId, optionPosition, behavior);
  }

  function realignPicker(formId, behavior) {
    initTrackDrag();
    initProductRerenderBindings();

    if (!formId) {
      document.querySelectorAll('variant-picker .product-form__option').forEach(function(optionRoot) {
        scrollActiveSwatchIntoView(optionRoot, behavior);
      });
      return;
    }

    var picker = document.querySelector('variant-picker[form-id="' + formId + '"]');

    if (!picker) {
      return;
    }

    picker.querySelectorAll('.product-form__option').forEach(function(optionRoot) {
      scrollActiveSwatchIntoView(optionRoot, behavior);
    });
  }

  function queuePickerRealign(formId, behavior) {
    var key = formId || '__all__';

    clearFrameBucket(pickerRealignFrames, key);

    pickerRealignFrames[key] = [];

    var frameId = window.requestAnimationFrame(function() {
      realignPicker(formId, behavior);

      var settleFrameId = window.requestAnimationFrame(function() {
        realignPicker(formId, behavior);
      });

      pickerRealignFrames[key] = [settleFrameId];
    });

    pickerRealignFrames[key].push(frameId);
  }

  function findTrack(target) {
    return target && target.closest ? target.closest(SWATCH_TRACK_SELECTOR) : null;
  }

  function bindTrackDrag(track) {
    if (!track || track.dataset.tuokusDragBound === 'true') {
      return;
    }

    track.dataset.tuokusDragBound = 'true';

    track.addEventListener('pointerdown', function(event) {
      if (event.pointerType === 'touch' || event.button !== 0) {
        return;
      }

      if (track.scrollWidth <= track.clientWidth + 1) {
        return;
      }

      dragState = {
        pointerId: event.pointerId,
        track: track,
        startX: event.clientX,
        startScrollLeft: track.scrollLeft,
        moved: false
      };
    });

    track.addEventListener('pointermove', function(event) {
      if (!dragState || dragState.track !== track || dragState.pointerId !== event.pointerId) {
        return;
      }

      var deltaX = event.clientX - dragState.startX;

      if (!dragState.moved && Math.abs(deltaX) > 5) {
        dragState.moved = true;
        track.classList.add('is-swatch-dragging');

        if (typeof track.setPointerCapture === 'function') {
          track.setPointerCapture(event.pointerId);
        }
      }

      if (dragState.moved) {
        event.preventDefault();
        track.scrollLeft = dragState.startScrollLeft - deltaX;
      }
    });

    function clearDrag(event) {
      if (!dragState || dragState.track !== track || dragState.pointerId !== event.pointerId) {
        return;
      }

      if (dragState.moved) {
        track.dataset.dragSuppressUntil = String(Date.now() + 180);
      }

      track.classList.remove('is-swatch-dragging');

      if (typeof track.hasPointerCapture === 'function' && track.hasPointerCapture(event.pointerId) && typeof track.releasePointerCapture === 'function') {
        track.releasePointerCapture(event.pointerId);
      }

      dragState = null;
    }

    track.addEventListener('pointerup', clearDrag);
    track.addEventListener('pointercancel', clearDrag);
    track.addEventListener('lostpointercapture', function() {
      track.classList.remove('is-swatch-dragging');
      dragState = null;
    });
    track.addEventListener('scroll', function() {
      persistTrackScroll(track);
    }, { passive: true });
  }

  function initTrackDrag() {
    document.querySelectorAll(SWATCH_TRACK_SELECTOR).forEach(bindTrackDrag);
  }

  function onVariantOptionInteraction(target) {
    var optionRoot = target && target.closest ? target.closest('.product-form__option') : null;
    var optionInput = null;
    var formId = null;
    var optionPosition = null;

    if (target && target.matches && target.matches('.product-form__single-selector[data-option-position]')) {
      optionInput = target;
    } else if (target && target.getAttribute) {
      var targetFor = target.getAttribute('for');

      if (targetFor) {
        optionInput = document.getElementById(targetFor);
      }
    }

    if (optionInput) {
      formId = optionInput.getAttribute('form') || (optionInput.form ? optionInput.form.id : null);
      optionPosition = optionInput.getAttribute('data-option-position');
    }

    if (formId && optionPosition) {
      rememberOptionScroll(formId, optionPosition, optionRoot);
      return;
    }

    if (!optionRoot) {
      return;
    }

    queueSwatchScroll(optionRoot, 'auto');
  }

  document.addEventListener('change', function(event) {
    var target = event.target;

    if (!target || !target.matches || !target.matches(
      '.product-form__single-selector[data-option-position], ' +
      '.color-swatch__radio, ' +
      '.block-swatch__radio, ' +
      '.variant-swatch__radio'
    )) {
      return;
    }

    onVariantOptionInteraction(target);

    if (target.matches('.product-form__single-selector[data-option-position]')) {
      scheduleForcedVariantSync(target);
    }
  });

  document.addEventListener('click', function(event) {
    var track = findTrack(event.target);
    var suppressUntil = track ? Number(track.dataset.dragSuppressUntil || 0) : 0;

    if (suppressUntil > Date.now()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    var label = event.target.closest(
      '.variant-swatch__item, .block-swatch__item, .color-swatch__item'
    );

    if (!label || !label.getAttribute('for')) {
      return;
    }

    var control = document.getElementById(label.getAttribute('for'));

    if (!control || !control.matches('.product-form__single-selector[data-option-position]') || control.disabled || control.checked) {
      return;
    }

    var optionRoot = label.closest('.product-form__option');
    var formId = control.getAttribute('form') || (control.form ? control.form.id : null);
    var optionPosition = control.getAttribute('data-option-position');

    if (formId && optionPosition) {
      rememberOptionScroll(formId, optionPosition, optionRoot);
    }

    control.checked = true;
    control.dispatchEvent(new Event('change', { bubbles: true }));
    queueSwatchScroll(optionRoot, 'auto');
    scheduleForcedVariantSync(control);
  });

  document.addEventListener('variant:changed', function(event) {
    var form = event.target;
    var formId = null;
    var optionPosition = null;

    if (form) {
      formId = form.id || (form.getAttribute ? form.getAttribute('form-id') : null);
    }

    if (!formId && event.detail && event.detail.formId) {
      formId = event.detail.formId;
    }

    if (formId) {
      optionPosition = lastOptionByForm[formId] || null;
    }

    if (formUsesProductRerender(formId)) {
      return;
    }

    if (!formId) {
      document.querySelectorAll('variant-picker .product-form__option').forEach(function(optionRoot) {
        queueSwatchScroll(optionRoot, 'auto');
      });
      return;
    }

    if (optionPosition) {
      queueOptionRealign(formId, optionPosition, 'auto');
      return;
    }

    queuePickerRealign(formId, 'auto');
  });

  document.addEventListener('DOMContentLoaded', function() {
    initTrackDrag();
    initProductRerenderBindings();
    document.querySelectorAll('variant-picker .product-form__option').forEach(function(optionRoot) {
      scrollActiveSwatchIntoView(optionRoot, 'auto');
    });
  });
})();
